'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
require('react');
require('prop-types');
const namespace = 'ui-seo-content-dates';
const ContentDates = props => {
  const {
    publishText,
    publishDate,
    updateText,
    updateDate
  } = props;
  const formatDate = date => new Date(date).toISOString().split('T')[0];
  const formattedPublishDate = formatDate(publishDate);
  const formattedUpdateDate = updateDate ? formatDate(updateDate) : '';
  const shouldShowUpdate = updateDate && new Date(formattedUpdateDate) > new Date(formattedPublishDate);
  return /*#__PURE__*/_jsx("div", {
    className: namespace
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace}__publish`
  }, void 0, /*#__PURE__*/_jsx("time", {
    datetime: formattedPublishDate
  }, void 0, publishText)), shouldShowUpdate && /*#__PURE__*/_jsx("div", {
    className: `${namespace}__update`
  }, void 0, /*#__PURE__*/_jsx("time", {
    datetime: formattedUpdateDate
  }, void 0, updateText)));
};
ContentDates.defaultProps = {
  updateText: '',
  updateDate: ''
};
ContentDates.displayName = 'ContentDates';
exports.default = ContentDates;
